import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError } from "@utils/errorHandler";

import { loadAllLead, loadSingleLead } from "./LeadList.slice";

import { loadAllLeadAPI, loadSingleLeadAPI } from "./LeadList.api";

export const LOAD_ALL_LEAD = {
  LOADING: "Load all lead loading",
  SUCCESS: "Load all lead success",
  ERROR: "Load all lead error",
};

export const LOAD_SINGLE_LEAD = {
  LOADING: "Load single lead loading",
  SUCCESS: "Load single lead success",
  ERROR: "Load single lead error",
};

function* loadAllLeadWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllLeadAPI, payload);
    yield put(loadAllLead(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_LEAD.ERROR, error });
  }
}

function* loadSingleLeadSagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleLeadAPI, payload);
    yield put(loadSingleLead(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_LEAD.ERROR, error });
  }
}

export function* loadAllLeadSaga() {
  yield takeLatest(LOAD_ALL_LEAD.LOADING, loadAllLeadWorker);
}

export function* loadSingleLeadSaga() {
  yield takeLatest(LOAD_SINGLE_LEAD.LOADING, loadSingleLeadSagaWorker);
}
